// Minimal DOM helpers. No framework (TECH_SPEC §4).

export interface ElOptions {
  class?: string;
  text?: string;
  attrs?: Record<string, string>;
  on?: Partial<Record<keyof HTMLElementEventMap, (e: Event) => void>>;
}

export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  opts: ElOptions = {},
  children: readonly (Node | string | null | undefined)[] = [],
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  if (opts.class) node.className = opts.class;
  if (opts.text !== undefined) node.textContent = opts.text;
  if (opts.attrs) {
    for (const [k, v] of Object.entries(opts.attrs)) node.setAttribute(k, v);
  }
  if (opts.on) {
    for (const [name, handler] of Object.entries(opts.on)) {
      if (handler) node.addEventListener(name, handler as EventListener);
    }
  }
  for (const child of children) {
    if (child === null || child === undefined) continue;
    node.append(child);
  }
  return node;
}

export function clear(node: HTMLElement): void {
  while (node.firstChild) node.removeChild(node.firstChild);
}

/** Fade a node in on the next frame (CSS handles the transition). */
export function enter(node: HTMLElement): void {
  node.classList.add('is-entering');
  requestAnimationFrame(() => {
    requestAnimationFrame(() => node.classList.remove('is-entering'));
  });
}

let toastTimer: ReturnType<typeof setTimeout> | null = null;

export function toast(root: HTMLElement, message: string, ms = 2200): void {
  const existing = root.querySelector('.toast');
  if (existing) existing.remove();
  const node = el('div', { class: 'toast', text: message });
  root.append(node);
  if (toastTimer !== null) clearTimeout(toastTimer);
  toastTimer = setTimeout(() => {
    node.classList.add('toast--out');
    setTimeout(() => node.remove(), 260);
  }, ms);
}
